import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { config } from "services/globalvariables/globalvariables";
import swal from "sweetalert";
import axios from "axios";

const initialState = {
    data: [],
    loading: false,
    error: false,
};

export const getLatestBlogs = createAsyncThunk(
    "getlatestblogs",
    async () => {
        try {
            const endPoint = `${process.env.REACT_APP_HOST}/showroom/api/v1/blog/list`;
            const response = await axios.get(endPoint, config);
            return response.data.data;
        } catch (err) {
            console.log(err);
            swal(`Something went wrong! ${JSON.stringify(err)}`);
            throw err;
        }
    }
);

const blogSlice = createSlice({
    name: "latestblogs",
    initialState,
    reducers: {
        setBlogs: (state, action) => {
            state.data = action.payload;
        },
        sortBlogsByTitle: (state, action) => {
            const order = action.payload;
            state.data = [...state.data].sort((a: any, b: any) => {

                const result = a.title.localeCompare(b.title);

                return order === "asc" ? result : -result;
            });
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLatestBlogs.pending, (state) => {
                state.loading = true;
            })
            .addCase(getLatestBlogs.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(getLatestBlogs.rejected, (state) => {
                state.loading = false;
                state.error = true;
            });
    },
});

export const { setBlogs, sortBlogsByTitle } = blogSlice.actions;
export default blogSlice.reducer;
